"use strict";

module.exports = {
  CHANGE_EVENT: "changed",
  FETCH_CHANGE_EVENT: "fetch-changed"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/store/storeEvents.js
 ** module id = 477
 ** module chunks = 0
 **/